import {Component, OnInit, ViewChild} from '@angular/core';
import {IndividualsComponent} from '../admin/individuals/individuals.component';
import {DataService} from 'src/app/services';
import {GroupsService} from 'src/app/services';
import {Individual} from 'src/app/models';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
    currentIndividual: any = {
        id: 0,
        external_id: '',
        device_name: '',
        first_name: '',
        last_name: '',
        full_name: '',
        preferred_contact_id: null,
        contacts: [],
        group_ownership: [],
        group_membership: [],
        active: true
    };

    userID = '';
    ready = false;
    currentGroups: any[] = [];
    ownedGroups: any[] = [];
    error = false;
    nameErrorText = 'No Results Found';
    @ViewChild('individualsComponent') individualsView: IndividualsComponent;

    constructor(
        private dataService: DataService,
        private groupsService: GroupsService,
        private individualsComponent: IndividualsComponent
    ) {
        this.currentIndividual = this.individualsComponent.currentIndividual;
    }

    ngOnInit() {
        this.initializeProfile();
    }

    initializeProfile() {
        this.dataService.getUserInfo().subscribe(resi => {
            // TODO: userservice getSelf with content[0] returned object
            this.dataService.getIndividualAndAssociateExactMatchLookup(resi['email']).subscribe({
                next: (res) => {
                    this.currentIndividual = res.content[0];
                    if (this.currentIndividual.id) {
                        this.groupsService.getGroupsByMemberID(this.currentIndividual.id).subscribe(() => {
                            this.currentGroups = this.individualsComponent.groups;
                            this.ready = true;
                        });
                        this.groupsService.getGroupsByMemberID(this.currentIndividual.id).subscribe(() => {
                            this.ownedGroups = this.individualsComponent.groupsOwned;
                        });
                    } else {
                        this.ready = true;
                    }
                }, error: err => {
                    this.error = true;
                    if (err.error && err.error.message.toLowerCase().includes('404') || err.message && err.message.toLowerCase().includes('404')) {
                        if (resi['family_name'].toLowerCase() === 'service account' || resi['family_name'].toLowerCase() === '[svc]' || resi.name.toLowerCase().includes('svc_')) {
                            this.currentIndividual = resi;
                            this.error = false;
                            this.ready = true;
                        } else {
                            this.nameErrorText = 'No results found';
                        }
                    } else {
                        this.nameErrorText = 'There was an issue accessing Associate Directory';
                    }
                }
            });
        });
        this.getCurrentUser();
    }

    getCurrentUser(): Individual {
        return this.currentIndividual;
    }

    getCurrentGroups(): any[] {
        return this.currentIndividual.group_membership;
    }

    getCurrentOwned(): any[] {
        return this.currentIndividual.group_ownership;
    }

    isIndividual(): boolean {
        return this.currentIndividual.id;
    }
}
